"use client";

import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

export default function PLabelsSection({ nameAlias }: { nameAlias: string }) {

    const tags = useMemo(() => {
        const raw = String(nameAlias ?? "").trim();
        if (!raw || raw === "برچسبی موجود نیست") return [];

        const items = raw.split("،").map((x) => x.trim()).filter(Boolean);

        return Array.from(new Set(items));
    }, [nameAlias]);

    if (tags.length === 0) {
        return (
            <Typography  fontSize = {14} textAlign="center" color="text.secondary" py={2}>
                برچسبی موجود نیست
            </Typography>
        );
    }

    return (
        <Box
            display="flex"
            flexWrap="wrap"
            gap={1}
        >
            {tags.map((tag) => (
                <Chip
                    key={tag}
                    label={tag}
                    size="small"

                />
            ))}
        </Box>
    );
}
